import { isAxiosError } from 'axios';
/** Extracts a human-readable message from a react-query/axios error for board error states. */
export function getErrorDetail(err) {
    if (isAxiosError(err)) {
        const data = err.response?.data;
        if (typeof data === 'object' && data !== null && 'detail' in data) {
            return String(data.detail);
        }
        return err.message;
    }
    if (err instanceof Error)
        return err.message;
    return 'Unknown error';
}
